
<template>
	<c-dialog ref="dialog" :title="'请选择需要核销数据的付款渠道'" width="500" @resolve="resolve">
		<c-form ref="form" unit-width="100%">
			<c-form-item  label="付款渠道" required>
                <c-radio-group name="check_payment_channel" v-model="check_payment_channel" :options="checkPaymentChannel" :clear="false">
                </c-radio-group>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
import {mapState} from 'vuex'
export default {
	name: 'paymentChannelSelector',
	components: {},

	computed: {
        ...mapState(['saasInfo'])
	},

	data() {
		return {
            check_payment_channel:0,
            checkPaymentChannel:[]
		}
	},

	props: {
	},

	methods: {
		/**
		 * @param exclude_process_ids  排除该工序不返回
		 */
		open() {
			this.$refs.form.clear();
            this.searchDicInfo();
			this.$refs.dialog.open();
		},

		/*******搜索【订单核销收款渠道】下拉框信息*****************/
        searchDicInfo() {
            this.request({
                url: '/dic/info/options',
                data: {
                    dic_type_code:'CHECK_PAYMENT_CHANNEL'
                },
                success: data => {
                    this.checkPaymentChannel = data.filter(item => item.value != '1')
                }
            })
        },

		resolve(stop) {
			if (this.check_payment_channel == 0){
				stop();
				this.$message({
					message: '请选择付款渠道',
					type: 'warn'
				});
				return;
			}
			var data = {};
			data.check_payment_channel = this.check_payment_channel;
			this.$emit('resolve', data);
		}
	}
}
</script>